import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Button from "@mui/material/Button";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import CustomSelect from "../CustomComponents/CustomSelect";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import moment from "moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import { MuiThemeProvider } from '@material-ui/core/styles'
import { muiThemeDesign } from '../../mui-theme-design';
import { muiThemePicker } from '../../mui-theme-design';
import MUIDataTable from 'mui-datatables';
import {logger, handleExport, customBodyForExcelReport,checkAuthentication,muiLoaderOptions,muiLoaderOptionsWithoutMUIDataTable} from '../../utils';
import { Box, Container } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { minWidth } from "@mui/system";


export default function BillingHistory () {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [POChoices, setPOChoices] = React.useState([]);
    const [originalPOChoices, setOriginalPOChoices] = React.useState([]);
    const [PO, setPO] = React.useState(1);
    const [POName, setPOName] = React.useState("");
    const [type, setType] = React.useState("lab");
    const [isLoading, setIsLoading] = React.useState(true);
    const [showInActive, setShowInActive] = React.useState(false); 

    const initialValues = {
        POID: ''
    };
    
    const convertDates = (json) => {
		json.forEach(eachObj => {
			if (eachObj.InvoiceDate) {
				eachObj.InvoiceDate = moment.utc(eachObj.InvoiceDate).format("MM/DD/YYYY");
			}
		});
		setDataSet(json);
		setIsLoading(false);
	};
    
    const validFormSchema = Yup.object({
        POID: Yup
            .string('Select a PO')
            .required('PO selection Required'),
            
    })

    const setChoices = (json) => {
        let choices = [];
        let originalChoices = [];
        json.forEach(choice => {
			if (!showInActive && choice.PoActive===1){
				choices.push({ label: choice.CommonName, value: choice.ID })
			} else if (showInActive){
				choices.push({ label: choice.CommonName, value: choice.ID })
			}
			originalChoices.push(choice)
		});
        setPOChoices(choices)
        setOriginalPOChoices(originalChoices);
    }

    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
             fetch('/api/PO/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setChoices(json);
				})
            setRefresh(false);
        }
    })

    const handleGenerate = () => {
        fetch(`/api/Reports/BillingReport/${PO}/${type}`, {
            method: 'GET',
        })
            .then(res => res.json())
            .then(json => {
                convertDates(json)
            })
        setOpenLogs(true);
    };

    const handleClickOpen = () => {
        setRefresh(true)
        setOpen(true)
    };   

    const handleClose = () => {
     //   setPOChoices(0);
        setOpen(false);
    };

    const handleOpenForLogs = () => {
        setOpenLogs(true)
    };

    const handleCloseForLogs = () => {
        setOpenLogs(false);
    }; 

    const columns = [
		{
			name: "InvoiceDate",
			label: "InvoiceDate",
			options: {
				filter: false,
				sort: true,
				customBodyRenderLite: (dataIndex) => {
					const dateValue = dataSet[dataIndex].InvoiceDate;
					if (dateValue && moment(dateValue).isValid()) {
						return moment.utc(dateValue).format("MM/DD/YYYY");
					} else {
						return 'N/A';
					}
				}
			}
		},

		{
			name: "Name",
			label: "Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "InvoiceNumber",
            label: "InvoiceNumber",
            options: {
                filter: true,
                sort: true,
            }
        },       
        {
            name: `${ type }`,
            label: `${type}`,
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Hours",
            label: "Hours",
            options: {
                filter: true,
                sort: true,
            }
        },
         {
            name: "Amount",
            label: "Invoice Amount",
            options: {
                filter: true,
                sort: true,
            }
        },
       /* {
            name: "Total",
            label: "Calculated Total",
            options: {
                filter: true,
                sort: true,
            }
        },*/
        {
            name: "DiscountedTotal",
            label: "Estimated Total",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
					var discount = dataSet[dataIndex].Discount/100;
					var total = dataSet[dataIndex].Total;
					
			        var totalValue = total - (total * discount)
			        logger(totalValue.toFixed(2));
			        return totalValue.toFixed(2);
                }
            }
        },
    ];

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        rowsPerPage: 100,
        responsive: 'standard',
        rowsPerPageOptions: [10, 20, 50, 100],
        textLabels: {
		    toolbar: {
		      search: "Search",
		      downloadCsv: "Download Excel", 
		      print: "Print",
		      viewColumns: "View Columns",
		      filterTable: "Filter Table",
		    	},
		},
        selectableRows: 'none',
		onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}

			const customBuildBody = () => {
				const headers = customBuildHead();
				
				for (var i = 0; i < data.length; i++) {
					var eachRow = data[i].data;
					var discount = dataSet[i].Discount/100;
					var total = dataSet[i].Total;
					
			        var totalValue = total - (total * discount)
			        logger(totalValue.toFixed(2));
			        eachRow[6] = totalValue.toFixed(2);
				}
				
				return customBodyForExcelReport({data:data, headers:headers});
			};

			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename:`BillingHistory.xlsx`});
			return false;
		}
    };
    
    const showInActivePOs = (show) => {
		setShowInActive(show);
		
		let choices = [];
        originalPOChoices.forEach(choice => {
			if (!show && choice.PoActive===1){
				choices.push({ label: choice.CommonName, value: choice.ID })
			} else if (show){
				choices.push({ label: choice.CommonName, value: choice.ID })
			}
		});
        setPOChoices(choices);
	};
 
    return (
        <div>
        <MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                Billing History Report
            </Button>
             <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            //onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                           edge="start"
                                           color="inherit"
                                           onClick={handleClose}
                                           aria-label="close"
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                           Billing History
                                        </Typography>
                                        <Button color="inherit" onClick={handleGenerate}>
                                            Generate
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                    <DialogTitle>Billing History:</DialogTitle>    
                                    {POChoices.length===0 ? muiLoaderOptionsWithoutMUIDataTable() :       
									<div>
										<div >
											<FormControl sx={{ m: 1, width: 220 }}>
												<InputLabel htmlFor="POSelection">PO Name</InputLabel>
												<CustomSelect
													name="POID"
													id="outlined-POSelection"
													options={POChoices}
													onChange={(e) => {
														setPO(e.target.value);
														setPOName(POChoices.filter(choice => choice.value === e.target.value)[0].label);
													}}
													value={PO}
													label="POID"
												/>
											</FormControl>
											<FormControl>
												<Tooltip title="Show InActive PO List" placement="top-start">
													<FormControlLabel control={<Checkbox checked={showInActive}
														onClick={() => { showInActivePOs(!showInActive) }} />} />
												</Tooltip>
											</FormControl>
										</div>
										<div sx={{ paddingTop: { xs: 10, sm: 10, md: 10, lg: 0, xl: 0 } }} >
											<FormControl>
												<RadioGroup
													aria-labelledby="demo-controlled-radio-buttons-group"
													name="controlled-radio-buttons-group"
													value={type}
	                                                onChange={(e) => {
	                                                    setType(e.target.value)
	                                                }}
	                                            >
	                                                <FormControlLabel value="lab" control={<Radio />} label="lab" />
	                                                <FormControlLabel value="project" control={<Radio />} label="project" />
	                                            </RadioGroup>
	                                        </FormControl>
									    </div>
								    </div>
								    }
                            </Form>
                        )}
                        </Formik>
                        <Dialog open={openLogs} onClose={handleCloseForLogs} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                            <DialogContent >
                                <Box>

                                    <MUIDataTable
                                        title={

                                            <Typography variant="h6" style={{ color: "white" }}>
                                                <IconButton edge="start" color="inherit" onClick={handleCloseForLogs} aria-label="close"> <CloseIcon /> </IconButton>
                                                 {POName} Billing History
                                            </Typography>
                                        }
                                        data={isLoading ? [] :dataSet}
                                        columns={columns}
                                        options={muiLoaderOptions(options, isLoading)}
                                    />
                                </Box>
                            </DialogContent>
                        </Dialog>
                </DialogContent>                
            </Dialog>
            </MuiThemeProvider>
        </div>
    );
}
 